import axios, { AxiosResponse } from "axios";
import { BaseResponse } from "../../common/interfaces/responses";
import { getErrorMsg } from "../../common/utils/http";

declare var pm: PmInterface;

export async function submitSubscribeForm(
	formData: FormData,
): Promise<BaseResponse> {
	try {
		const axiosResponse: AxiosResponse<BaseResponse> = await axios({
			method: "post",
			url: pm.ajaxurl,
			data: formData,
		});

		return axiosResponse.data;
	} catch (error: unknown) {
		const msg = axios.isAxiosError(error)
			? getErrorMsg(error)
			: "An unknown error occurred.";

		return {
			success: false,
			message: msg,
		};
	}
}
